// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"earphone"},"children":[{"tag":"g","attrs":{"id":"fill1"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M3 14C6 14 6 14 6 14C7.10457 14 8 14.8954 8 16V18C8 19.1046 7.10457 20 6 20H3V14Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M16 16C16 14.8954 16.8954 14 18 14H21V20H18C16.8954 20 16 19.1046 16 18V16Z"}}]},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M3 20V12.0667C3 7.05929 7.02944 3 12 3C16.9706 3 21 7.05929 21 12.0667V20M3 20H6C7.10457 20 8 19.1046 8 18V16C8 14.8954 7.10457 14 6 14C6 14 6 14 3 14V20ZM21 20V14H18C16.8954 14 16 14.8954 16 16V18C16 19.1046 16.8954 20 18 20H21Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const EarphoneIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'earphone',
    ref,
    icon: element,
  },
));

EarphoneIcon.displayName = 'EarphoneIcon';

export default EarphoneIcon;
